module.exports = __webpack_public_path__ + "img/heatcad-mj8.b12c71c6.png";